// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating ClientToken response body.
 * @see #/components/schemas/ClientTokenResponse - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface ClientTokenResponse {
    /**
     * The client bearer token.
     *
     */
    token: string;
    /**
     * duration in seconds when this token will expire.
     *
     */
    expires_in: number;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for ClientTokenResponse
 */
export namespace ClientTokenResponse {
    /**
     * ClientTokenResponse Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The client bearer token.
         * @type string (`dataFormat` is missing)
         */
        token: string;
        /**
         * duration in seconds when this token will expire.
         * @type number (`dataFormat` is missing)
         */
        expiresIn: number;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * ClientTokenResponse DTO
     * Transforms ClientTokenResponse model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend ClientTokenResponse model */
        static toModel(obj: ClientTokenResponse): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend ClientTokenResponse model */
        static toApi(obj: Model): ClientTokenResponse {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as ClientTokenResponse;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
